import { useState } from "react";
import VLAvatar from "views/uikit/VLAvatar";
import TrashIcon from "assets/icons/TrashIcon";
import styles from "./style.module.scss";
import classNames from "classnames";
import ConfirmationDialog from "../ConfirmationDialog";
import { CgSpinner } from "react-icons/cg";

export const UserRow = ({
  email,
  name,
  avatarIcon = (
    <div>
      <VLAvatar size="xsmall" />
    </div>
  ),
  subtitle,
  classname,
  onRemoveUser,
  dataTestId,
}: {
  email: string;
  name?: string;
  avatarIcon?: React.ReactNode;
  subtitle?: string;
  classname?: string;
  onRemoveUser?: () => Promise<void>;
  dataTestId?: string;
}) => {
  const [removeInProgress, setRemoveInProgress] = useState<boolean>(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
  const showRemoveButton = !!onRemoveUser;
  const handleRemoveClick = () => {
    setShowConfirmDialog(true);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false);
  };

  const handleConfirmRemove = async () => {
    if (!onRemoveUser) {
      return;
    }
    setShowConfirmDialog(false);
    setRemoveInProgress(true);
    await onRemoveUser();
    setRemoveInProgress(false);
  };

  const renderRowEnd = () => {
    if (subtitle) {
      return subtitle;
    }
    if (removeInProgress) {
      return (
        <div className={styles.spinner} data-testid="spinner">
          <CgSpinner size={"20px"} />
        </div>
      );
    } else {
      return (
        <div data-testid="trash-icon">
          <TrashIcon />
        </div>
      );
    }
  };
  return (
    <>
      <div
        className={classNames(styles.userWithAccessRow, classname)}
        key={email}
        data-testid={dataTestId}
      >
        {avatarIcon}
        <div>
          {name && <div>{name}</div>}
          <div>{email}</div>
        </div>
        <div
          className={classNames(styles.userRowEnd, {
            [styles.trashIcon]: showRemoveButton,
            [styles.trashIconClicked]: showConfirmDialog,
          })}
          onClick={showRemoveButton ? handleRemoveClick : () => {}}
        >
          {renderRowEnd()}
        </div>
      </div>
      {showConfirmDialog && (
        <div className={styles.removeConfirmationDialog}>
          <ConfirmationDialog
            title="Remove Member"
            bodyText="Are you sure you want to remove this user?"
            confirmText="Remove Member"
            onCancel={handleCancel}
            onConfirm={handleConfirmRemove}
          />
        </div>
      )}
    </>
  );
};
